export default {
  title: "Notifications",
  viewAll: "View all",
  markAsRead: "Mark as read",
  markAllAsRead: "Mark all as read",
  noNotifications: "No notifications",
  
  types: {
    info: "Information",
    warning: "Warning",
    error: "Error",
    success: "Success"
  },
  
  actions: {
    view: "View",
    dismiss: "Dismiss",
    accept: "Accept",
    decline: "Decline"
  },

  categories: {
    system: "System",
    tasks: "Tasks",
    guests: "Guests",
    budget: "Budget",
    vendors: "Vendors",
    timeline: "Timeline",
    achievements: "Achievements",
    weddingWebsite: "Wedding Website"
  },
  
  settings: {
    title: "Notification Settings",
    push: {
      title: "Push Notifications",
      description: "Receive notifications even when not using the app"
    },
    categories: {
      title: "Notification Categories"
    },
    other: {
      title: "Other Notifications",
      email: {
        title: "Email Notifications",
        description: "Receive important updates by email"
      },
      desktop: {
        title: "Desktop Notifications",
        description: "Receive notifications on your computer"
      }
    },
    testButton: "Test Notifications"
  },
  
  errors: {
    loadPreferences: "Error loading notification preferences",
    pushToggle: "Error changing push notification preferences",
    categoryToggle: "Error changing category preferences"
  }
};

